import { formatBytes } from './exportFormat';

/**
 * Leitura de um job de exportação completa (company_export_jobs) na interface.
 * get_history.php devolve snake_case (include_attachments, total_bytes,
 * current_task, expires_at, download_url) e status.php devolve camelCase
 * (includeAttachments, totalBytes, currentTask, expiresAt, downloadUrl); o
 * acompanhamento do histórico mescla as duas formas na mesma linha, então
 * lemos as duas, preferindo a do status (mais recente).
 */

export const ACTIVE_EXPORT_STATUSES = ['pending', 'processing'];

export const getIncludeAttachments = (item) => !!(item?.includeAttachments ?? item?.include_attachments);
export const getTotalBytes = (item) => item?.totalBytes ?? item?.total_bytes;
export const getExpiresAt = (item) => item?.expiresAt ?? item?.expires_at;
export const getCurrentTask = (item) => item?.currentTask ?? item?.current_task ?? null;

// Partes com link assinado (o backend só devolve URL para o que dá para baixar).
export const getDownloadParts = (item) => (Array.isArray(item?.parts) ? item.parts.filter((part) => part?.url) : []);
export const getDownloadUrl = (item) => getDownloadParts(item)[0]?.url || item?.downloadUrl || item?.download_url || null;

export const isExportActive = (item) => !!item && ACTIVE_EXPORT_STATUSES.includes(item.status);

// 'YYYY-MM-DD HH:MM:SS' do backend como data local; null quando inválida.
export const parseExportDateTime = (value) => {
    if (!value) return null;
    const date = new Date(String(value).replace(' ', 'T'));
    return isNaN(date.getTime()) ? null : date;
};

// Concluída, com link e ainda dentro do prazo do download (24 horas).
export const isExportDownloadable = (item) => {
    if (!item || item.status !== 'complete' || !getDownloadUrl(item)) return false;
    const expiresAt = parseExportDateTime(getExpiresAt(item));
    return !expiresAt || expiresAt > new Date();
};

// Exportação mais recente do histórico (get_history.php ordena por created_at DESC).
export const latestExportJob = (history) => (Array.isArray(history) && history.length > 0 ? history[0] : null);

// Sufixo do rótulo "Incluir anexos e fotos" a partir de estimate.php.
export const attachmentsEstimateLabel = (estimate) => {
    if (!estimate) return '';
    const count = estimate.attachments?.count || 0;
    if (count <= 0) return ' (nenhum anexo ainda)';

    const size = formatBytes(estimate.attachments.totalBytes);
    const parts = estimate.estimatedParts > 1 ? `, em ${estimate.estimatedParts} arquivos` : '';
    return ` (≈ ${size}${parts})`;
};
